package com.xtream.video_player

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import com.xtream.core_model.dto.MovieSubtitle
import com.xtream.video_player.util.ProjectContentScale
import kotlin.js.js

@Composable
actual fun BaseComposeMedia3Player(
    url: String,
    modifier: Modifier,
    title: String?,
    contentScale: ProjectContentScale,
    surfaceType: Int,
    onPlaybackLoadingChange: (currentPosInMillis: Long, durationInMillis: Long) -> Unit,
    onPlaybackEnded: (() -> Unit)?,
    onScreenResizeClicked: () -> Unit,
    onMenuClicked: (() -> Unit)?,
    hideAfterMillis: Long,
    infos: List<String>?,
    progress: Long,
    onPlayerClicked: () -> Unit,
    controllersUI: @Composable ((Boolean, () -> Unit, () -> Unit, () -> Unit) -> Unit)?,
    subtitles: List<MovieSubtitle.Subtitle?>?,
    enableControls: Boolean,
    onNavigationIconClick: () -> Unit
) {
   WebPlayer(
       url =url,
       modifier = modifier ,
       title = title ,
       contentScale = contentScale ,
       surfaceType = surfaceType ,
       onPlaybackLoadingChange = onPlaybackLoadingChange,
       onPlaybackEnded = onPlaybackEnded ,
       onScreenResizeClicked = onScreenResizeClicked ,
       onMenuClicked = onMenuClicked ,
       hideAfterMillis = hideAfterMillis ,
       infos = infos ,
       progress = progress ,
       onPlayerClicked = onPlayerClicked ,
       controllersUI = controllersUI ,
       subtitles = subtitles ,
       enableControls = enableControls ,
       onNavigationIconClick =onNavigationIconClick
   )
}
@Composable
expect fun WebPlayer(    url: String,
                         modifier: Modifier,
                         title: String?,
                         contentScale: ProjectContentScale,
                         surfaceType: Int,
                         onPlaybackLoadingChange: (currentPosInMillis: Long, durationInMillis: Long) -> Unit,
                         onPlaybackEnded: (() -> Unit)?,
                         onScreenResizeClicked: () -> Unit,
                         onMenuClicked: (() -> Unit)?,
                         hideAfterMillis: Long,
                         infos: List<String>?,
                         progress: Long,
                         onPlayerClicked: () -> Unit,
                         controllersUI: @Composable ((Boolean, () -> Unit, () -> Unit, () -> Unit) -> Unit)?,
                         subtitles: List<MovieSubtitle.Subtitle?>?,
                         enableControls: Boolean,
                         onNavigationIconClick: () -> Unit)